module.exports = __webpack_public_path__ + "assets/5dcdd951ec582a4307280d9918cd6f2f.svg";